import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  AnchorModule,
  HeaderModule,
  IconModule,
  ListModule,
  SidenavModule,
  SkipLinksModule,
  PoptipModule,
} from '@virginmediao2/momentum-angular';
import { HeaderWrapperComponent } from './header-wrapper.component';
import { HeaderLoginNavComponent } from './header-login-nav/header-login-nav.component';
import { HeaderSideNavComponent } from './header-side-nav/header-side-nav.component';
import { DividerLineModule } from '@challenger6/vm-pattern-library/divider-line';
import { ScreenOverlayModule } from '@challenger6/vm-pattern-library/screen-overlay/screen-overlay.module';
import { VmGlobalConfigModule } from '@challenger6/vm-pattern-library/config';

@NgModule({
  declarations: [HeaderLoginNavComponent, HeaderSideNavComponent, HeaderWrapperComponent],
  imports: [
    CommonModule,
    HeaderModule,
    AnchorModule,
    SkipLinksModule,
    RouterModule,
    IconModule,
    SidenavModule,
    ListModule,
    PoptipModule,
    DividerLineModule,
    ScreenOverlayModule,
    VmGlobalConfigModule,
  ],
  exports: [HeaderLoginNavComponent, HeaderSideNavComponent, HeaderWrapperComponent],
})
export class HeaderWrapperModule {}
